import React from "react";
import { Box } from "@chakra-ui/react";

export const Container = (props) => (
  <Box mt={"70px"} w="full" mx="auto" maxW="3xl" px={{ base: "6", md: "8" }} {...props} />
);

export default Container;
